import * as React from "react";
const SvgFiRrTimeAdd = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#062147" clipPath="url(#fi-rr-time-add_svg__a)">
      <path d="M23 18h-3v-3a1 1 0 0 0-2 0v3h-3a1 1 0 0 0 0 2h3v3a1 1 0 0 0 2 0v-3h3a1 1 0 0 0 0-2M11 7v4.586l-2.707 2.707a1 1 0 1 0 1.414 1.414l3-3A1 1 0 0 0 13 12V7a1 1 0 0 0-2 0" />
      <path d="M14.728 21.624a9.986 9.986 0 1 1 6.9-6.895.998.998 0 0 0 1.079 1.296 1 1 0 0 0 .845-.754 11.99 11.99 0 1 0-8.276 8.277 1.002 1.002 0 0 0 .532-1.592 1 1 0 0 0-1.076-.332z" />
    </g>
    <defs>
      <clipPath id="fi-rr-time-add_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTimeAdd;
